import PropTypes from "prop-types"
import { Chip } from "@mui/material"

export default function ResourcesChip({ resourceLimits, newResourceCount }) {
  if (!resourceLimits) { return null }
  const { current, limit } = resourceLimits
  return <Chip label={`Resources utilized: ${current + newResourceCount} / ${limit}`} color="primary" />
}

ResourcesChip.propTypes = {
  resourceLimits: PropTypes.shape({
    current: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
  }),
  newResourceCount: PropTypes.number.isRequired,
}
